import { useEffect } from 'react'
import { useLocation } from 'wouter'

import { useAuth } from '../hooks/useAuth'
import { useIsModal } from '@/Router'
import { APP_BASE, appPath } from '@/utils/appPath'

function parseReturnTo() {
  const search = new URLSearchParams(location.search)

  for (const [key, value] of search.entries()) {
    if (key === 'return_to') {
      return value
    }
  }
}

// Return paths are relative to the router base. Links from the website still contain the old `/app`
// prefix, also when the admin app runs on its own host.
function stripBase(path?: string) {
  if (!path) return

  for (const prefix of [APP_BASE, '/app']) {
    if (prefix && (path === prefix || path.startsWith(`${prefix}/`))) {
      return path.slice(prefix.length) || '/'
    }
  }

  return path
}

export const RedirectIfSignedIn: React.FC = () => {
  const { isSignedIn } = useAuth()
  const [location, navigate] = useLocation()
  const needsBackground = useIsModal()

  useEffect(() => {
    if (isSignedIn) {
      const returnTo = stripBase(parseReturnTo()) ?? '/goodies'

      if (returnTo.startsWith('/api')) {
        window.location.href = returnTo

        return
      }

      const isModal = needsBackground(returnTo)

      // We need to make sure that we don't leave the SignIn or whatever in the background
      if (isModal) {
        navigate(returnTo, { state: { background: appPath('/goodies') } })
      } else {
        navigate(returnTo)
      }
    }
  }, [location, isSignedIn, needsBackground, navigate])

  return null
}
